import { config, mode } from '../../config';
import { createDemoDb } from './demoDb';
import { createSupabaseDb } from './supabaseDb';
import type { Db } from './types';

export type { Db } from './types';

/** The database: Supabase when the keys are set, otherwise this browser (demo mode). */
export const db: Db = mode === 'supabase' ? createSupabaseDb(config.supabaseUrl, config.supabaseAnonKey) : createDemoDb();
